/* eslint-disable linebreak-style */
import React from 'react';

const ethIcon = (fill: string, size: number, style?: React.CSSProperties) => (
    <svg
        aria-hidden="true"
        data-testid="test-icon"
        id="Layer_x0020_1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 39.1"
        style={style}
    >
        <title>eth icon</title>
        <g id="12">
            <g id="Group_1522" data-name="Group 1522">
                <path
                    id="Path_1705"
                    data-name="Path 1705"
                    d="M383.762,0,383.5.891V26.756l.262.262,12.006-7.1Z"
                    transform="translate(-371.776)"
                    // fill={fill || '#343434'}
                    fill={fill}
                    fillOpacity="0.8"
                />
                <path
                    id="Path_1706"
                    data-name="Path 1706"
                    d="M12.006,0,0,19.921l12.006,7.1V0Z"
                    // fill={fill || '#8c8c8c'}
                    fill={fill}
                    fillOpacity="0.4"
                />
                <path
                    id="Path_1707"
                    data-name="Path 1707"
                    d="M387.388,731.983l-.148.18v9.214l.148.432L399.4,724.89Z"
                    transform="translate(-375.401 -702.709)"
                    // fill={fill || '#3c3c3b'}
                    fill={fill}
                    fillOpacity="0.8"
                />
                <path
                    id="Path_1708"
                    data-name="Path 1708"
                    d="M12.006,741.809v-9.826L0,724.89Z"
                    transform="translate(0 -702.709)"
                    // fill={fill || '#8c8c8c'}
                    fill={fill}
                    fillOpacity="0.4"
                />
                <path
                    id="Path_1709"
                    data-name="Path 1709"
                    d="M392.07,484.884l12.006-7.1L392.07,472.33Z"
                    transform="translate(-380.083 -457.875)"
                    // fill={fill || '#141414'}
                    fill={fill}
                    fillOpacity="0.8"
                />
                <path
                    id="Path_1710"
                    data-name="Path 1710"
                    d="M0,477.787l12.006,7.1V472.33Z"
                    transform="translate(0 -457.875)"
                    // fill={fill || '#393939'}
                    fill={fill}
                    fillOpacity="0.4"
                />
            </g>
        </g>
    </svg>
);
export default ethIcon;
